import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { AlertApi } from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { SeverityEnum } from '../../../enums/SeverityEnum';
import { getMessage } from '../../../utils/getMessage';
import { isOkayResponse } from './checks';

export const patchResourceData = async ({
  workloadClient,
  workload,
  resourceName,
  payload,
}: {
  workloadClient: WorkloadClient;
  workload?: string;
  resourceName?: string;
  payload: { [_: string]: string | string[] };
}) => {
  return await workloadClient.apiFetch(
    `workloads/workload/${workload}/resource/${resourceName}`,
    'PATCH',
    payload,
  );
};

export const updateResource = async ({
  workloadClient,
  workloadObject,
  payload,
  stopLoadingAndCloseModal,
  alertApi,
  killProcessAndReportError,
}: {
  workloadClient: WorkloadClient;
  workloadObject: any;
  payload: { [_: string]: string | string[] };
  stopLoadingAndCloseModal: Function;
  alertApi: AlertApi;
  killProcessAndReportError: Function;
}): Promise<boolean> => {
  try {
    const patchResourceDataResponse = await patchResourceData({
      workloadClient,
      workload: workloadObject.workload,
      resourceName: workloadObject.resourceName,
      payload,
    });
    if (!isOkayResponse(patchResourceDataResponse)) {
      stopLoadingAndCloseModal();
      alertApi.post({
        message: getMessage({
          failureToDo: 'update your resource with the data provided',
        }).FAILURE,
        severity: SeverityEnum.ERROR,
      });
      return false;
    }
  } catch (e: any) {
    killProcessAndReportError(e);
    return false;
  }
  return true;
};

export const postWorkloadApply = async ({
  githubWorkloadAlias,
  workloadClient,
  payload,
}: {
  githubWorkloadAlias: string;
  workloadClient: WorkloadClient;
  payload: any;
}): Promise<Response> => {
  if (githubWorkloadAlias === undefined) return Promise.resolve(new Response());

  const url = `workloads/workload/${githubWorkloadAlias}/apply`;
  return await workloadClient.apiFetch(url, 'POST', payload);
};

export const processApplyChangeResponse = async (
  applyChangeResponse: Response,
  entity: Entity,
  alertApi: any,
  catalogApi: any,
) => {
  if (isOkayResponse(applyChangeResponse)) {
    const applyChangeResponseJson = await applyChangeResponse.json();

    alertApi.post({
      message: getMessage({
        successMessage: applyChangeResponseJson?.message,
      }).SUCCESS,
      severity: SeverityEnum.SUCCESS,
    });

    await catalogApi.refreshEntity(stringifyEntityRef(entity));

    alertApi.post({
      message: getMessage().REFRESHING,
      severity: SeverityEnum.INFO,
    });
  } else {
    alertApi.post({
      message: getMessage({ failureToDo: 'post to apply endpoint' }).FAILURE,
      severity: SeverityEnum.ERROR,
    });
  }
  return Promise.resolve();
};
